/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerandSuppliersbyCityModule
 * Purpose		: Module for CustomerandSuppliersbyCity.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { SharedModule } from '../shared/Shared.module';

import { CustomerandSuppliersbyCityService } from './CustomerandSuppliersbyCity.service';
import { CustomerandSuppliersbyCityListComponent } from './CustomerandSuppliersbyCityList.component';
import { CustomerandSuppliersbyCitySearchComponent } from './CustomerandSuppliersbyCitySearch.component';
import { CustomerandSuppliersbyCityDetailsComponent } from './CustomerandSuppliersbyCityDetails.component';

import { CustomerandSuppliersbyCityRoutingModule } from './CustomerandSuppliersbyCity-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
	SharedModule,
    CustomerandSuppliersbyCityRoutingModule
  ],
  declarations: [
    CustomerandSuppliersbyCityListComponent,
	CustomerandSuppliersbyCitySearchComponent,
	CustomerandSuppliersbyCityDetailsComponent
  ],
  providers: [
    CustomerandSuppliersbyCityService
  ]
})

export class CustomerandSuppliersbyCityModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/CustomerandSuppliersbyCity/CustomerandSuppliersbyCity.module.ts